
import { YoungQuestion } from '@/types/personality';

// Questions for Impaired Limits Domain
export const impairedLimitsQuestions: YoungQuestion[] = [
  // Esquema: Merecimento/Grandiosidade
  {
    id: 28,
    text: "Tenho grande dificuldade em aceitar um 'não' como resposta quando quero alguma coisa dos outros.",
    domain: "impaired_limits",
    schema: "entitlement"
  },
  {
    id: 29,
    text: "Frequentemente tenho tanta raiva quando não consigo o que quero que não consigo expressar meus verdadeiros sentimentos.",
    domain: "impaired_limits",
    schema: "entitlement"
  },
  {
    id: 30,
    text: "Sou especial e não deveria ter que aceitar muitas das restrições impostas às outras pessoas.",
    domain: "impaired_limits",
    schema: "entitlement"
  },
  
  // Esquema: Autocontrole Insuficiente
  {
    id: 31,
    text: "Parece que não consigo me disciplinar para completar tarefas rotineiras ou entediantes.",
    domain: "impaired_limits",
    schema: "insufficient_self_control"
  },
  {
    id: 32,
    text: "Se não consigo atingir uma meta, facilmente me frustro e desisto.",
    domain: "impaired_limits",
    schema: "insufficient_self_control"
  },
  {
    id: 33,
    text: "Tenho muita dificuldade em sacrificar gratificações imediatas para atingir objetivos de longo prazo.",
    domain: "impaired_limits",
    schema: "insufficient_self_control"
  }
];
